import {createReducer, createAsyncThunk} from '@reduxjs/toolkit'
import SettingProps from '../../props_reusable/settings'
import configService from '../../services/config.service'
import utils from '../../utils'

const initialState = {} as SettingProps

export const fetchConfig = createAsyncThunk(
  'fetchConfig',
  (orderGUID: string) => {
    return configService
      .getConfig<SettingProps>(orderGUID)
      .catch(utils.routeToErrorPage)
  },
)

const orderConfigReducer = createReducer(initialState, builder => {
  builder.addCase(fetchConfig.fulfilled, (state, action) => {
    return action.payload
  })
})

export default orderConfigReducer
